import Component from './Breadcrumb.vue';

export default {
  install(Vue) {
    Vue.component('BkfVBreadcrumb', Component);
  },
};
